import "./BlogArticle.css";
import BlogTemplate from "../../components/BlogTemplate/BlogTemplate"
import { Link } from "react-router-dom";

const ShareIcon = ({ type }) => {
  const svgs = {
    facebook: <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>,
    twitter: <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>,
    linkedin: <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/>,
    whatsapp: <path fillRule="evenodd" d="M13.65 2.33A8.48 8.48 0 0 0 8 0C3.58 0 0 3.58 0 8c0 1.62.48 3.13 1.31 4.38L.07 15.39a.5.5 0 0 0 .63.63l3.15-1.2c1.2.65 2.55 1 4 1 4.42 0 8-3.58 8-8 0-2.13-.83-4.06-2.2-5.49zM8 14.5a6.46 6.46 0 0 1-3.27-.9.5.5 0 0 0-.42-.06l-2.26.87.88-2.14a.5.5 0 0 0-.07-.47A6.46 6.46 0 0 1 1.5 8c0-3.58 2.92-6.5 6.5-6.5S14.5 4.42 14.5 8 11.58 14.5 8 14.5zm3.17-4.3c-.18-.1-.92-.46-1.06-.51-.14-.05-.25-.07-.35.11-.1.18-.4.51-.49.61-.09.1-.18.12-.33.04-.96-.47-1.55-.82-2.17-1.3-.16-.13-.02-.4.1-.53.1-.1.23-.26.34-.4.1-.13.14-.23.2-.38.07-.15.03-.28-.02-.4-.04-.1-.35-.86-.48-1.17-.13-.32-.26-.27-.35-.27-.09 0-.2-.01-.31-.01s-.28.04-.43.2c-.15.16-.57.56-.57 1.37 0 .8.59 1.58.67 1.69.08.1 1.15 1.76 2.79 2.47.39.17.69.27.93.35.39.12.74.1 1.02.06.31-.04.96-.39 1.1-.77.13-.38.13-.7.09-.77-.04-.07-.15-.11-.33-.19z"/>,
    clipboard: <path fillRule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
      {svgs[type]}
    </svg>
  );
};

function shareLinks(url, title) {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  return [
    { name: 'Facebook', href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, icon: <ShareIcon type="facebook" />, brand: '#1877f2' },
    { name: 'X (Twitter)', href: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`, icon: <ShareIcon type="twitter" />, brand: '#000' },
    { name: 'LinkedIn', href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`, icon: <ShareIcon type="linkedin" />, brand: '#0a66c2' },
    { name: 'WhatsApp', href: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`, icon: <ShareIcon type="whatsapp" />, brand: '#25d366' },
  ];
}

function readingTime(html) {
  const text = (html || "").replace(/<[^>]*>/g, "");
  const words = text.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}

function BlogArticle(props) {
  const url = window.location.href;
  const title = props.title || 'SoloChat';
  const author = props.author || 'SoloChat';
  const formattedDate = props.date
    ? new Date(props.date).toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })
    : '';
  const authorInitial = author.charAt(0).toUpperCase();

  return (
    <div className="blogDetailPage">
      <article className="detail">
        <div className="backLink">
          <Link to="/blog">← Back to Blog</Link>
        </div>

        <header className="postHeader">
          <h1>{props.title}</h1>
          <div className="meta">
            <div className="authorAvatar">{authorInitial}</div>
            <div className="authorInfo">
              <span className="author">{author}</span>
              <div className="metaDetail">
                <time className="date">{formattedDate}</time>
                <span className="separator">•</span>
                <span className="readTime">{readingTime(props.article)} min read</span>
              </div>
            </div>
          </div>
        </header>

        {props.image &&
          <div className="heroImage">
            <img
              src={props.image}
              alt={props.title}
            />
          </div>}

        <div className="content">
          <BlogTemplate data={props.article} />
        </div>

        <footer className="shareSection">
          <h3>Share this post</h3>
          <div className="shareButtons">
            {shareLinks(url, title).map(s => (
              <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer" className="shareBtn" title={s.name} style={{ '--brand': s.brand }}>
                {s.icon}
              </a>
            ))}
            <button className="shareBtn" title="Copy link" onClick={() => { navigator.clipboard.writeText(url); alert('Link copied!'); }}>
              <ShareIcon type="clipboard" />
            </button>
          </div>
        </footer>
      </article>
    </div>
  );
}

export default BlogArticle;
